// extracted by mini-css-extract-plugin
export default {"block":"Qf","loading":"Rf","spinner":"Sf","spin":"Tf"};